import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import Utils from './assets/js/lib/utils';
import Util from './assets/js/lib/util';
import m9377Routers from "./routers/m9377";
import mengwRouters from "./routers/mengw";
import chuangyueRouters from "./routers/chuangyue";

let platformRouter = [];
switch (import.meta.env.VITE_PLATFORM) {
    case 'mengw':
        platformRouter = mengwRouters;
        break;
    case'm9377':
        platformRouter = m9377Routers;
        break;
    case 'chuangyue':
        platformRouter = chuangyueRouters;
        break;
}

const utils = new Utils();

const router = createRouter({
    // 指定路由的模式,此处使用的是history模式
    // 路由基础路径固定为 /，不受 CDN 路径影响
    history: createWebHistory('/'),
    // 路由地址
    routes: platformRouter,
})

router.beforeEach(async (to, from, next) => {
    console.log({to, from})
    try {
        let title;
        switch (import.meta.env.VITE_PLATFORM) {
            case 'mengw':
                title = '梦玩盒子';
                break;
            case 'chuangyue':
                title = '蔚蓝星球社区';
                break;
            default:
                title = '9377大师';
                break;
        }
        const username = utils.getUserName();
        if (to?.meta?.hasOwnProperty('title')) {
            title = to.meta.title;
        }
        document.title = title;

        // 避免路由重定向循环
        if (to.fullPath === from.fullPath && to.name === from.name) {
            console.warn('检测到路由重定向循环，跳过');
            next(false);
            return;
        }

        // 检查缓存组件导航问题
        if (window._routeErrorCount && window._routeErrorCount[to.path] > 3) {
            console.warn(`路径 ${to.path} 出现多次导航错误，重置应用状态`);
            // 重置应用状态
            window._routeErrorCount = {};
            // 强制刷新以重置应用
            window.location.href = to.fullPath;
            return;
        }

        // 检测在微信小程序环境下，如果路由name是game，重定向到index
        if (to.name === 'game') {
            try {
                const util = new Util();
                const isWxMiniapp = await util.isWechatMiniapp();
                if (isWxMiniapp) {
                    console.log('在微信小程序环境中，从game路由重定向到index');
                    if(import.meta.env.VITE_PLATFORM == 'chuangyue') {
                        next({ name: 'welfare' });
                        return;
                    }
                    // else {
                    //     window.Components.toast('666')
                    //     next({ name: 'game' });
                    // }
                    // return;
                }
            } catch (err) {
                console.error('检测微信小程序环境失败:', err);
            }
        }

        // SDK页面处理
        if (to.path.indexOf('/sdk') > -1 && !username) {
            // 检查URL中是否包含access_token参数，如果包含则允许继续导航
            // const hasAccessToken = utils.getUrlParam('access_token');
            // if (hasAccessToken) {
            //     // 有token的情况下允许访问，登录流程会在App.vue中处理
            //     console.log('允许带token的SDK页面访问:', to.path);
            //     next();
            //     return;
            // }

            window.reloadSdkPage = to.fullPath;
            next(false);
            return;
        }

        // 检查DOM元素是否存在，如果不存在尝试修复
        const appElement = document.getElementById('app');
        if (!appElement || appElement.childNodes.length === 0) {
            console.warn('路由导航前，#app元素不存在或为空，尝试修复');
            const appDiv = document.getElementById('app') || document.createElement('div');
            appDiv.id = 'app';
            if (!document.body.contains(appDiv)) {
                document.body.appendChild(appDiv);
            }
        }

        next();
    } catch (error) {
        console.error('路由守卫错误:', error);
        // 发生错误时仍然允许导航
        next();
    }
})

// 添加全局导航后置钩子
router.afterEach((to, from) => {
    try {
        // 导航完成后检查DOM元素
        setTimeout(() => {
            const appElement = document.getElementById('app');
            if (!appElement || appElement.childNodes.length === 0) {
                console.warn('路由导航后，#app元素不存在或为空，尝试修复');
                const appDiv = document.getElementById('app') || document.createElement('div');
                appDiv.id = 'app';
                if (!document.body.contains(appDiv)) {
                    document.body.appendChild(appDiv);
                }
            }
        }, 0);
    } catch (error) {
        console.error('导航后钩子错误:', error);
    }
});

// 处理路由错误
router.onError((error) => {
    console.error('路由错误:', error);

    // 记录错误次数，用于检测持续错误
    if (!window._routeErrorCount) {
        window._routeErrorCount = {};
    }

    const currentPath = router.currentRoute.value.path;
    window._routeErrorCount[currentPath] = (window._routeErrorCount[currentPath] || 0) + 1;

    // 尝试恢复页面
    if (error.name === 'NavigationDuplicated') {
        console.warn('导航重复，忽略此错误');
    } else if (error.message && error.message.includes('Failed to load')) {
        console.warn('组件加载失败，尝试回到首页');
        // 如果频繁发生错误，强制刷新页面
        if (window._routeErrorCount[currentPath] > 2) {
            console.warn('多次加载失败，强制刷新页面');
            window.location.href = '/';
        } else {
            router.push('/').catch(err => console.warn('回到首页失败:', err));
        }
    }
});

export default router;
